import React, { Component } from 'react'
import { Form, Button, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
// import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import { i18nTranslate } from 'src/utils'
import {
  Icons,
  ConfirmationModal,
  SubscriptionProductTile,
  toastState,
} from 'src/views/components'
import { sortingPvItem } from './deps'
import { application } from 'src/utils'
import {
  subscriptionContainer,
  customerContainer,
  cartContainer,
} from 'src/models'
import SubscriptionInfiniteScroll from 'src/views/components/SubscriptionInfiniteScroll'
import './styles.scss'

const modalMessage = i18nTranslate(
  'pvAssistant.deletePvProductContent',
  'Clicking “Confirm Delete” below will result in the permanent deletion of these items.'
)

@observer
class ShowPvProductList extends Component {
  @observable enableConfirmation = false
  @observable isPvEnabled = false
  @observable pvGoal = 0
  @observable isSetGoalClicked = false
  @observable pvGoalInputValue = 0
  @observable pvAssistItems = []
  @observable addedPvItem = {}
  @observable pvCurrencySign = ''

  constructor(props) {
    super(props)
  }

  componentDidMount() {
    this.getPVAssistantDetails()
  }

  getPVAssistantDetails = async () => {
    const pvResponse = await subscriptionContainer.getAllPvAssistProduct(
      customerContainer.userId
    )
    const pvGoalResponse =
      await subscriptionContainer.getAllSubscriptionsPreference(
        customerContainer.userId
      )
    this.pvGoal =
      pvGoalResponse?.pvAssistGoal != 0 && pvGoalResponse?.pvAssistGoal
        ? pvGoalResponse?.pvAssistGoal
        : 0
    this.pvGoalInputValue = this.pvGoal
    this.isPvEnabled = pvGoalResponse?.pvAssistEnabled
    this.pvCurrencySign = pvResponse?.currencySign
  }

  handleRenderUpDown = async (index, type = 'up') => {
    let pvAssistItems = [...this.props.selectedPvItems]
    pvAssistItems = pvAssistItems?.length > 0 && sortingPvItem(pvAssistItems)
    const pvItemPriority = type === 'up' ? index : index + 2
    const id =
      type === 'up'
        ? pvAssistItems[index - 1]?.id
        : pvAssistItems[index + 1]?.id
    const postData = [
      { id: pvAssistItems[index]?.id, itempriority: pvItemPriority },
      { id, itempriority: index + 1 },
    ]
    await subscriptionContainer.patchPvAssistItems(
      customerContainer.userId,
      postData
    )
  }

  handleDeleteAllItems = () => {
    this.enableConfirmation = true
  }

  handleCancelDelete = () => {
    this.enableConfirmation = false
  }

  handleConfirmDelete = async () => {
    const { handleMultipleProductsDelete } = this.props
    this.enableConfirmation = false
    if (typeof handleMultipleProductsDelete === 'function') {
      await handleMultipleProductsDelete('pvAssistPage')
    }
  }

  highlightSelectedPvProduct = selectedItem => {
    const selectedItemDetails = selectedItem?.[0]
    const itemInfo = selectedItemDetails?.itemInfo?.[0] || []
    const selectedPvSkuID = itemInfo?.skus?.[0]?.id || ''
    const itemPriority = itemInfo?.properties?.itempriority || ''
    this.addedPvItem = {
      skuId: selectedPvSkuID,
      itemPriority: itemPriority,
    }
  }

  handleDeleteAllCheckbox = pvAssistItems => {
    if (subscriptionContainer.selectedSubscriptionProducts?.size) {
      subscriptionContainer.selectedSubscriptionProducts?.clear()
      subscriptionContainer.selectedProductsTotalPV = 0.0
    } else {
      pvAssistItems.forEach((item, index) => {
        const itemId = item?.id || 0
        const pv = parseFloat(item?.properties?.pointValue || '00.00')
        subscriptionContainer.selectedSubscriptionProducts.add(itemId)
        subscriptionContainer.selectedProductsTotalPV = Math.abs(
          subscriptionContainer.selectedProductsTotalPV + pv
        )
      })
    }
  }

  handlePvAssistItemDeleteCheckbox = (itemId, pv) => {
    if (subscriptionContainer.selectedSubscriptionProducts?.has(itemId)) {
      subscriptionContainer.selectedSubscriptionProducts?.delete(itemId)
    } else {
      subscriptionContainer.selectedSubscriptionProducts.add(itemId)
    }
  }

  handleData = async data => {
    this.isSetGoalClicked = !this.isSetGoalClicked
    const postData = {
      pvAssistEnabled: this.isPvEnabled,
      pvAssistGoal: this.pvGoalInputValue,
    }
    const response = await subscriptionContainer.updateSubscriptionsPreference(
      customerContainer.userId,
      postData
    )
    if (subscriptionContainer.isSuccessResponse(response)) {
      this.pvGoal = this.pvGoalInputValue
    } else {
      const isServiceFailure = response?.isServiceFailure || false
      const errorMessage = isServiceFailure
        ? i18nTranslate(
            'subscription.somethingwentwrong',
            'Sorry, something went wrong. Please try again.'
          )
        : response && response.message
      toastState.setToastMessage(errorMessage, false)
    }
    setTimeout(() => {
      this.isSetGoalClicked = false
    }, 3000)
  }

  changePvToggle = async () => {
    this.isPvEnabled = !this.isPvEnabled
    const postData = {
      pvAssistEnabled: this.isPvEnabled,
    }
    const response = await subscriptionContainer.updateSubscriptionsPreference(
      customerContainer.userId,
      postData
    )
    this.pvGoalInputValue = this.pvGoal
    subscriptionContainer.selectedSubscriptionProducts.clear()
    return response
  }

  handleInputChange = event => {
    const regex = /^[0-9\b]+$/
    if (
      event.target.value === '' ||
      (event.target.value !== '' && regex.test(event.target.value))
    ) {
      this.pvGoalInputValue = event.target.value
    }
  }

  renderSubscriptionPointValueSummary = () => {
    let minMonthlyPV = subscriptionContainer.pvTotal
    return (
      <div className="subscription-summary">
        <div className="subscription-summary-title text-uppercase d-flex justify-content-between pb-4">
          <span>
            {i18nTranslate('pvAssistant.pvSummary', 'PV Assistant Summary')}
          </span>
        </div>
        <div className="subscription-summary-item d-flex justify-content-between pb-4">
          <span>{i18nTranslate('pvAssistant.isActive', 'Active')}</span>
          <Form.Check
            className="p-0 custom-switch pv-toggler-switch"
            id={`active`}
            style={{ outline: 'none' }}
            custom
            checked={this.isPvEnabled}
            label=""
            onClick={() => {
              this.changePvToggle()
            }}
          />
        </div>
        <div className="subscription-summary-item d-flex justify-content-between pb-4">
          <span>
            {i18nTranslate('pvAssistant.totalPV', 'PV Total')}
            <OverlayTrigger
              placement="top"
              delay={{ show: 100, hide: 250 }}
              overlay={
                <Tooltip className="overlay-content" id="pv-tool-tip-overlay">
                  {`${i18nTranslate(
                    'subscriptions.pvToolTip',
                    'This amount reflects the current total of all items in your PV Assist list. Please check that this amount is at least equal to your PV goal'
                  )}`}
                </Tooltip>
              }>
              <span>
                <Icons
                  name="product-icon"
                  icontype="tool-tip"
                  isPvAssistPage={true}
                  width="20px"
                  height="20px"
                  className="tooltip-icon-pv"
                />
              </span>
            </OverlayTrigger>
          </span>
          <span
            className="d-flex"
            data-testid="qa-user-sub-min-monthy-pv-value">
            <span className="font-weight-bold">
              {subscriptionContainer.pvTotal}
            </span>
            {minMonthlyPV >= this.pvGoal ? (
              <span className="success-tick">
                <Icons
                  name="CRUD"
                  icontype="tick"
                  width="15px"
                  height="15px"
                  color="#3E7957"
                />
              </span>
            ) : (
              <span className="failure-tick">
                <Icons
                  name="CRUD"
                  width="15px"
                  height="15px"
                  icontype="cross"
                  color="#BE1217"
                  className="ml-1"
                />
              </span>
            )}
          </span>
        </div>
        <div className="subscription-summary-item d-flex justify-content-between pb-4">
          <span>{i18nTranslate('pvAssistant.pvGoal', 'PV Goal')}</span>
          <span className="font-weight-bold" data-testid="pv-goal">
            {this.pvGoal}
          </span>
        </div>
        <div className="pv-set">
          <p className="mt-2 mb-2">
            {i18nTranslate('pvAssistant.setPVGoal', 'Set PV Goal')}
          </p>
        </div>
        <div className="d-flex class-form">
          <input
            id="pvGoal"
            value={this.pvGoalInputValue}
            onFocus={() => {
              this.isSetGoalClicked = false
            }}
            onChange={this.handleInputChange}
            className="pv-goal-input w-100 d-block"
            label="setPvGoal"
            disabled={!this.isPvEnabled}
          />
          {!this.isSetGoalClicked ? (
            <Button
              data-testid="set-goal-btn"
              onClick={() => {
                this.handleData()
              }}
              className="myaccount-btn mt-2 mt-md-0 btn btn-primary w-100 ml-2 text-uppercase"
              variant="primary"
              disabled={!this.isPvEnabled || this.pvGoalInputValue <= 0}
              type="submit">
              {i18nTranslate('pvAssistant.setGoal', 'Set Goal')}
            </Button>
          ) : (
            <Button
              data-testid="set-btn"
              className="myaccount-btn mt-2 mt-md-0 btn btn-primary w-100 ml-2 text-uppercase"
              variant="primary"
              disabled={!this.isPvEnabled || this.pvGoalInputValue <= 0}
              type="submit">
              {i18nTranslate('pvAssistant.set', 'Set')}
              <Icons
                name="CRUD"
                icontype="tick"
                width="18px"
                height="18px"
                color="#fff"
              />
            </Button>
          )}
        </div>
      </div>
    )
  }

  renderPvProducts = () => {
    const pvAssistItems =
      this.pvAssistItems?.length > 0
        ? this.pvAssistItems
        : this.props.selectedPvItems
    const selectedProductCount =
      subscriptionContainer.selectedSubscriptionProducts?.size
    const isToSelectDeleteAll = selectedProductCount != 0 ? true : false
    let pvAssistItemsCount = pvAssistItems?.length
    const selectedItemTitle = pvAssistItemsCount == 1 ? 'item' : 'items'
    const selectedProducts = `${selectedProductCount} ${i18nTranslate(
      'mysubscriptions.selectedProducts',
      ' selected'
    )}`
    let deletePvProductsText =
      selectedProductCount === 1
        ? i18nTranslate('pvAssistant.delete', 'Delete') +
          ' ' +
          selectedProductCount +
          ' ' +
          i18nTranslate('pvAssistant.item', 'item') +
          ' ?'
        : i18nTranslate('pvAssistant.delete', 'Delete') +
          ' ' +
          selectedProductCount +
          ' ' +
          i18nTranslate('pvAssistant.items', 'items') +
          ' ?'
    let pvItemSubscriptions = [...pvAssistItems]
    pvItemSubscriptions =
      pvItemSubscriptions?.length > 0 && sortingPvItem(pvItemSubscriptions)

    return (
      <>
        <SubscriptionInfiniteScroll
          handleSubscription={this.props.handlePvAssistance}
          selectedItemSkuId={this.highlightSelectedPvProduct}
          isPvAssistPage={true}
          isPvActive={this.isPvEnabled}
        />
        {pvItemSubscriptions?.length > 0 && (
          <div className="d-flex justify-content-between align-items-center delete-all-wrap">
            <div className="d-flex">
              <Form.Check
                className="subs-delete-all-checkbox"
                custom
                id="subscription-month-product-checkbox"
                checked={isToSelectDeleteAll}
                label={
                  <span className="sr-only">
                    {i18nTranslate(
                      'subscription.deleteMultipleProductCheckbox',
                      'Delete Multiple Subscription Products Checkbox'
                    )}
                  </span>
                }
                onChange={() => this.handleDeleteAllCheckbox(pvAssistItems)}
                disabled={!this.isPvEnabled}
              />
              <Button
                variant="transparent"
                className="delete-all-button shadow-none rounded-0 p-0 primary-button "
                onClick={this.handleDeleteAllItems}
                data-testid="qa-user-subs-all-product-delete"
                disabled={!this.isPvEnabled || !isToSelectDeleteAll}>
                <Icons
                  name="CRUD"
                  icontype="delete"
                  customicon="Delete"
                  width="20px"
                  alt={i18nTranslate('subscription.trashIcon', 'trash icon')}
                  ariaLabel={i18nTranslate(
                    'subscription.trashIcon',
                    'trash icon'
                  )}
                  fill="#3a3a3a"
                />
              </Button>
              {this.enableConfirmation && (
                <ConfirmationModal
                  showConfirmationModal={this.enableConfirmation}
                  handleConfirm={this.handleConfirmDelete}
                  handleCancel={this.handleCancelDelete}
                  handleHide={this.handleCancelDelete}
                  modalMessage={modalMessage}
                  renderText={deletePvProductsText}
                />
              )}
            </div>
            <div className="products-selected">
              <span>{`${pvAssistItemsCount} ${selectedItemTitle}`}</span>
              {selectedProductCount != 0 && (
                <span className="pl-1">({selectedProducts})</span>
              )}
            </div>
          </div>
        )}
        <div>
          {pvItemSubscriptions.length > 0 &&
            pvItemSubscriptions.map((item, index) => {
              const itemPriority =
                item?.itemInfo?.[0]?.properties?.itempriority || ''

              let disableArrow =
                itemPriority == pvItemSubscriptions?.length ? true : false
              const productStatus = item?.itemInfo?.[0]?.skus?.[0]?.status || ''
              const productSkuId = item?.itemInfo?.[0]?.skus?.[0]?.id || ''
              const isSubscription =
                item?.itemInfo?.[0]?.properties?.issubscription || ''

              const isProductStatusInactive =
                productStatus == 'INACTIVE' || isSubscription === false
              const stockStatus = (
                item?.itemInfo?.[0]?.skus?.[0]?.inventory || ''
              ).toLowerCase()
              const isStockError =
                stockStatus == 'out of stock' || stockStatus == 'discontinued'

              return (
                <div key={`pv-subs-${index}`} className="drag-facet-list">
                  <SubscriptionProductTile
                    data={item}
                    key={index}
                    index={index}
                    itemPriority={itemPriority}
                    isStockError={isStockError}
                    isProductStatusInactive={isProductStatusInactive}
                    handleFrequencyChange={this.props.handleFrequencyChange}
                    handleQuantityChange={this.props.handleQuantityChange}
                    currencySign={this.pvCurrencySign}
                    handleProductDelete={this.handlePvAssistItemDeleteCheckbox}
                    isPvAssistantPage={true}
                    renderUpDown={this.handleRenderUpDown}
                    disable={disableArrow}
                    isProductAddedInSubscriptionScreen={
                      productSkuId === this.addedPvItem?.skuId &&
                      itemPriority === this.addedPvItem?.itemPriority
                        ? true
                        : false
                    }
                    isToDisableDeleteCheckbox={!this.isPvEnabled}
                  />
                </div>
              )

              // const renderSection = (
              //   <div>
              //     <Draggable
              //       key={index}
              //       isDragDisabled={!this.isPvEnabled}
              //       draggableId={index.toString()}
              //       index={index}>
              //       {(provided, snapshot) => (
              //         <div
              //           className="drag-facet-list"
              //           ref={provided.innerRef}
              //           {...provided.draggableProps}
              //           {...provided.dragHandleProps}>
              //           <SubscriptionProductTile
              //             data={item}
              //             key={index}
              //             index={index}
              //             itemPriority={itemPriority}
              //             isStockError={isStockError}
              //             isProductStatusInactive={isProductStatusInactive}
              //             handleFrequencyChange={
              //               this.props.handleFrequencyChange
              //             }
              //             handleQuantityChange={this.props.handleQuantityChange}
              //             currencySign={this.pvCurrencySign}
              //             handleProductDelete={
              //               this.handlePvAssistItemDeleteCheckbox
              //             }
              //             isPvAssistantPage={true}
              //             renderUpDown={this.handleRenderUpDown}
              //             disable={disableArrow}
              //             isProductAddedInSubscriptionScreen={
              //               productSkuId === this.addedPvItem?.skuId &&
              //               itemPriority === this.addedPvItem?.itemPriority
              //                 ? true
              //                 : false
              //             }
              //             isToDisableDeleteCheckbox={!this.isPvEnabled}
              //           />
              //         </div>
              //       )}
              //     </Draggable>
              //   </div>
              // )

              // return renderSection
            })}
        </div>
      </>
    )
  }

  // onDragEnd = (result = {}) => {
  //   /**
  //    * 1) result will be a object created when we drag the items.-- ECS7-694
  //    * 2) this will contain the index of the source point and destination point
  //    * 3) the below condition is given to avoid the sceanario of dropping out of the droppable div
  //    **/
  //   if (!result.destination) {
  //     return
  //   }

  //   let pvAssistItems
  //   try {
  //     pvAssistItems = JSON.parse(JSON.stringify(this.props.selectedPvItems))
  //     pvAssistItems = pvAssistItems.length > 0 && sortingPvItem(pvAssistItems)
  //   } catch (e) {
  //     console.error('JSON.parse may be an error >>> onDragEnd', e)
  //   }

  //   const [removed] = pvAssistItems.splice(result.source.index, 1)
  //   pvAssistItems.splice(result.destination.index, 0, removed)
  //   let postData = []
  //   let updatedPvAssistItems = []

  //   pvAssistItems.length > 0 &&
  //     pvAssistItems.map((item, index) => {
  //       let formingData = {
  //         id: item.id,
  //         itempriority: index + 1,
  //       }
  //       let updatingItemPriority = item
  //       updatingItemPriority.itemInfo[0].properties.itempriority = index + 1
  //       postData.push(formingData)
  //       updatedPvAssistItems.push(updatingItemPriority)
  //     })
  //   subscriptionContainer.selectedPvItems = updatedPvAssistItems
  //   subscriptionContainer.patchPvAssistItems(customerContainer.userId, postData)
  // }

  renderPvProductsView = () => {
    const pvProductsView = this.renderPvProducts()
    return (
      <div>
        <div className="title-section d-flex align-items-center">
          <h2
            className="text-capitalize subscription-items-title pv-title-font"
            data-testid="qa-user-sub-your-subs-title">
            {i18nTranslate('pvAssistant.pvAssistantTitle', 'PV Assistant')}
          </h2>
        </div>
        <div className="pv-assistant-desc">
          {i18nTranslate(
            'pvAssistant.pvAssistantDescription',
            'Enter your desired monthly PV goal. When needed, PV Assistant will add products to your Subscribe to Save order to keep you over your PV goal. Note: PV Assistant adds products in the top-to-bottom order you choose.'
          )}
        </div>
        {pvProductsView}
      </div>
    )
  }

  render() {
    const pvItems =
      this.pvAssistItems && this.pvAssistItems?.length > 0
        ? this.pvAssistItems
        : subscriptionContainer.selectedPvItems
    const selectedPvItemSize =
      subscriptionContainer.selectedSubscriptionProducts?.size
    //const enableConfirmation = this.enableConfirmation
    const hasSubscription =
      cartContainer?.subscriptionResponse?.isSubscriptionPreference || false

    const isRenderEnabled =
      this.props.subscriptionProducts?.length > 0 ||
      hasSubscription ||
      pvItems?.length > 0 ||
      selectedPvItemSize > 0 ||
      this.enableConfirmation

    return (
      <>
        {isRenderEnabled && (
          <div
            className={`subscription-product-view d-flex ${
              application.isMobile
                ? 'justify-content-center flex-column-reverse'
                : ''
            }`}>
            <div className="left-section mt-2">
              {this.renderPvProductsView()}
            </div>
            <div className={'right-section ml-4 subscription-savings p-3 mb-2'}>
              {this.renderSubscriptionPointValueSummary()}
            </div>
          </div>
        )}
      </>
    )

    // return (
    //   <>
    //     {isRenderEnabled && (
    //       <div
    //         className={`subscription-product-view d-flex ${
    //           application.isMobile
    //             ? 'justify-content-center flex-column-reverse'
    //             : ''
    //         }`}>
    //         <DragDropContext onDragEnd={this.onDragEnd}>
    //           <Droppable isDropDisabled={false} droppableId="hey">
    //             {(provided = {}, snapshot) => (
    //               <div
    //                 className="left-section mt-2"
    //                 {...provided.droppableProps}
    //                 ref={provided.innerRef}>
    //                 {this.renderPvProductsView()}
    //                 {provided.placeholder}
    //               </div>
    //             )}
    //           </Droppable>
    //         </DragDropContext>
    //         <div className={'right-section ml-4 subscription-savings p-3 mb-2'}>
    //           {this.renderSubscriptionPointValueSummary()}
    //         </div>
    //       </div>
    //     )}
    //   </>
    // )
  }
}

export default ShowPvProductList
export { ShowPvProductList }
